module.exports = __webpack_public_path__ + "gushiActive.3f24dcc2.png";